import _ from 'lodash';

const LABEL_PREFIX_MAPPING = {
  basedIn: 'Based in '
};

const LABEL_SUFFIX_MAPPING = {
  investmentCount: ' PropTech Investment(s)'
};

export const getLabel = ({ investor, extended = false }) => {
  let data = {
    basedIn: _.get(investor, 'region') || '',
    type: _.startCase(_.get(investor, 'type'))
  };

  if (extended) {
    data = {
      ...data,
      investmentCount: _.get(investor, 'investments.length', '')
    };
  }

  const filteredData = _.omitBy(data, item => item === '');

  const prefixedFilteredData = _.mapValues(
    filteredData,
    (value, key) => `${_.get(LABEL_PREFIX_MAPPING, key, '')}${value}`
  );

  const prefixedAndSuffixedData = _.mapValues(
    prefixedFilteredData,
    (value, key) => `${value}${_.get(LABEL_SUFFIX_MAPPING, key, '')}`
  );

  return _.join(_.values(prefixedAndSuffixedData), ' | ');
};
